import { render, staticRenderFns } from "./ExchangeItemDetails.vue?vue&type=template&id=30ab1a9c&scoped=true&"
import script from "./ExchangeItemDetails.vue?vue&type=script&lang=js&"
export * from "./ExchangeItemDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeItemDetails.vue?vue&type=style&index=0&id=30ab1a9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab1a9c",
  null
  
)

export default component.exports